import React, { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { CurrentDossierProvider } from '@europrocurement/l2d-modules/modules/Dossiers/providers/CurrentDossierProvider';
import { dossiersBasePath } from '@europrocurement/l2d-modules/modules/Dossiers/constants/paths';
import DossierDocumentsProviderWrapper from './DossierDocumentsProviderWrapper';

type Props = { children: ReactNode };

/**
 * Conditionally wraps the layout with CurrentDossierProvider + DossierDocumentsProvider
 * when the current path matches a dossier detail route (/dossiers/:idDossier[/...]).
 *
 * Placed above FullLayout so that both B2DCustomHeader and the page <Outlet /> share
 * the same provider instances, allowing actions in the custom header to update the page.
 */
const CurrentDossierProviderAndDocumentsWrapper: React.FunctionComponent<Props> = function ({
    children,
}) {
    const { pathname } = useLocation();
    const dossierPathRegex = new RegExp(`^/${dossiersBasePath}/(\\d+)`);
    const match = pathname.match(dossierPathRegex);
    const idDossier = match?.[1];

    if (!idDossier) {
        return children as React.ReactElement;
    }

    return (
        <CurrentDossierProvider
            autoload
            idDossier={idDossier}
        >
            <DossierDocumentsProviderWrapper>{children}</DossierDocumentsProviderWrapper>
        </CurrentDossierProvider>
    );
};

export default CurrentDossierProviderAndDocumentsWrapper;
